import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ButtonLink from '../../ButtonLink';
import styles from './MeetingRescheduleButton.module.scss';
import { useIsMeetingReschedulable } from '../../../../data/hooks/meeting/useIsMeetingReschedulable';
import { isMeetingConfirmed } from 'common-data-handling';

function MeetingRescheduleButton(props) {
    const { className = '', eventId, meeting } = props,
        i18n = useI18n(),
        isReschedulable = useIsMeetingReschedulable(eventId, meeting),
        confirmed = isMeetingConfirmed(meeting);

    if (!isReschedulable) return null;

    return (
        <ButtonLink className={[className, styles.MeetingRescheduleButton].join(' ')} href="./reschedule">
            {confirmed ? i18n['label.reschedule.confirmed'] : i18n['label.reschedule']}
        </ButtonLink>
    );
}

export default MeetingRescheduleButton;
